/* Mr. Airco concept 2026 */
(function () {
'use strict';
var VAT = 1.21;
var KEY = 'mra_btw';
var fmt = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR' });
var fmt0 = new Intl.NumberFormat('nl-NL', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0, minimumFractionDigits: 0 });
function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }
function isB2B() { var el = document.querySelector('[data-mra-b2b]'); return el && el.getAttribute('data-mra-b2b') === 'true'; }
function inclMode() { var s = store(KEY); if (s === 'incl') return true; if (s === 'excl') return false; return !isB2B(); }
function money(cents, round) { var v = cents / 100; return round ? fmt0.format(Math.round(v)) : fmt.format(v); }
window.mraMoney = function (cents, round) { return money(inclMode() ? cents : cents / VAT, round); };
function applyBtw() {
var incl = inclMode();
document.querySelectorAll('[data-mra-price]').forEach(function (el) {
var c = parseInt(el.getAttribute('data-cents'), 10); if (isNaN(c)) return;
el.textContent = money(incl ? c : c / VAT, el.hasAttribute('data-round'));
});
document.querySelectorAll('[data-mra-btw-label]').forEach(function (el) { el.textContent = incl ? 'incl. btw' : 'excl. btw'; });
document.querySelectorAll('[data-mra-btw-toggle]').forEach(function (b) {
b.setAttribute('aria-pressed', incl ? 'true' : 'false');
var i = b.querySelector('[data-mra-btw-incl]'), x = b.querySelector('[data-mra-btw-excl]');
if (i) i.classList.toggle('is-on', incl); if (x) x.classList.toggle('is-on', !incl);
});
document.dispatchEvent(new CustomEvent('mra:btw'));
}
window.mraApplyBtw = applyBtw;
document.addEventListener('click', function (e) {
var t = e.target.closest('[data-mra-btw-toggle]'); if (!t) return;
store(KEY, inclMode() ? 'excl' : 'incl'); applyBtw();
});
function setCount(n) {
document.querySelectorAll('[data-mra-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = !n; });
document.querySelectorAll('[data-mra-cart-link]').forEach(function (a) { a.setAttribute('aria-label', 'Winkelwagen, ' + n + ' artikelen'); });
}
function addItems(items) {
var drawer = document.querySelector('cart-drawer');
var body = { items: items };
if (drawer) body.sections = 'cart-drawer,cart-icon-bubble';
return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body)
}).then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || 'Toevoegen mislukt'); return j; }); })
.then(function (j) {
fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); });
if (drawer && j.sections && typeof drawer.renderContents === 'function') {
try { drawer.classList.remove('is-empty'); drawer.renderContents({ id: items[0].id, sections: j.sections }); } catch (err) { }
}
return j;
});
}
window.mraAddItems = addItems;
document.addEventListener('click', function (e) {
var b = e.target.closest('[data-mra-quick-add]'); if (!b) return;
e.preventDefault(); b.disabled = true;
addItems([{ id: Number(b.getAttribute('data-mra-quick-add')), quantity: 1 }])
.then(function () { b.classList.add('is-added'); })
.catch(function (err) { alert(err.message); })
.finally(function () { b.disabled = false; });
});
document.addEventListener('change', function (e) {
var s = e.target.closest('[data-mra-sort]'); if (!s) return;
var u = new URL(window.location.href); u.searchParams.set('sort_by', s.value); u.searchParams.delete('page'); window.location.href = u.toString();
});
function initPdp(root) {
if (root.__mra) return; root.__mra = true;
var main = root.querySelector('[data-mra-main-img]');
var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-mra-thumb]'));
var idx = 0;
function show(i) {
if (!thumbs.length || !main) return; idx = (i + thumbs.length) % thumbs.length;
var t = thumbs[idx]; main.src = t.getAttribute('data-src'); main.removeAttribute('srcset'); main.alt = t.getAttribute('data-alt') || '';
thumbs.forEach(function (x, n) { x.classList.toggle('is-active', n === idx); x.setAttribute('aria-current', n === idx ? 'true' : 'false'); });
}
thumbs.forEach(function (t, n) { t.addEventListener('click', function () { show(n); }); });
root.querySelectorAll('[data-mra-gal]').forEach(function (b) { b.addEventListener('click', function () { show(idx + Number(b.getAttribute('data-mra-gal'))); }); });
var qty = root.querySelector('[data-mra-qty]');
root.querySelectorAll('[data-mra-qty-step]').forEach(function (b) {
b.addEventListener('click', function () { qty.value = Math.max(1, (parseInt(qty.value, 10) || 1) + Number(b.getAttribute('data-mra-qty-step'))); update(); });
});
if (qty) qty.addEventListener('input', update);
var variantSel = root.querySelector('[data-mra-variant]');
var priceEl = root.querySelector('[data-mra-main-price-wrap] [data-mra-price]');
var compareEl = root.querySelector('[data-mra-main-compare]');
var installEl = root.querySelector('[data-mra-install-total]');
var installAdd = Number(root.getAttribute('data-install') || 0);
var btn = root.querySelector('[data-mra-atc]');
var btnLabel = btn ? btn.querySelector('span') : null;
var baseLabel = btnLabel ? btnLabel.textContent : '';
var note = root.querySelector('[data-mra-extras-note]');
var msg = root.querySelector('[data-mra-atc-msg]');
var ups = Array.prototype.slice.call(root.querySelectorAll('[data-mra-up]'));
function currentPrice() {
if (variantSel) { var o = variantSel.options[variantSel.selectedIndex]; return Number(o.getAttribute('data-price')); }
return Number(root.getAttribute('data-price'));
}
function extras() {
var list = [];
ups.forEach(function (u) {
if (!u.classList.contains('is-on')) return;
var sel = u.querySelector('select'); var id, price;
if (sel) { var o = sel.options[sel.selectedIndex]; id = Number(o.value); price = Number(o.getAttribute('data-price')); }
else { id = Number(u.getAttribute('data-id')); price = Number(u.getAttribute('data-price')); }
list.push({ id: id, price: price });
});
return list;
}
function labels() {
var p = currentPrice(); var q = Math.max(1, parseInt(qty && qty.value, 10) || 1);
var ex = extras(); var exSum = ex.reduce(function (t, x) { return t + x.price; }, 0);
if (btnLabel && (!btn || !btn.disabled || ex.length)) btnLabel.textContent = ex.length ? 'Toevoegen · ' + window.mraMoney(p * q + exSum) : baseLabel;
if (note) { note.hidden = !ex.length; note.textContent = '+ ' + ex.length + (ex.length === 1 ? ' extra' : " extra's") + ' (' + window.mraMoney(exSum) + ') worden meegenomen in je bestelling'; }
}
function update() {
var p = currentPrice();
if (priceEl) priceEl.setAttribute('data-cents', p);
if (variantSel && compareEl) { var o = variantSel.options[variantSel.selectedIndex]; var c = Number(o.getAttribute('data-compare') || 0); compareEl.hidden = !(c > p); if (compareEl.firstElementChild) compareEl.firstElementChild.setAttribute('data-cents', c); }
if (installEl) installEl.setAttribute('data-cents', p + installAdd);
ups.forEach(function (u) {
var sel = u.querySelector('select'); var pe = u.querySelector('[data-mra-up-price]');
if (sel && pe) { var o = sel.options[sel.selectedIndex]; pe.setAttribute('data-cents', o.getAttribute('data-price')); }
});
applyBtw();
}
document.addEventListener('mra:btw', labels);
if (variantSel) variantSel.addEventListener('change', function () {
var o = variantSel.options[variantSel.selectedIndex];
if (btn) btn.disabled = o.hasAttribute('data-soldout');
var u = new URL(window.location.href); u.searchParams.set('variant', variantSel.value); history.replaceState(null, '', u.toString());
update();
});
ups.forEach(function (u) {
var t = u.querySelector('[data-mra-up-toggle]');
t.addEventListener('click', function () {
var on = !u.classList.contains('is-on'); u.classList.toggle('is-on', on);
t.setAttribute('aria-pressed', on ? 'true' : 'false'); t.textContent = on ? 'Toegevoegd' : '+ Voeg toe'; update();
});
var sel = u.querySelector('select'); if (sel) sel.addEventListener('change', update);
});
if (btn) btn.addEventListener('click', function () {
var id = variantSel ? Number(variantSel.value) : Number(root.getAttribute('data-variant'));
var q = Math.max(1, parseInt(qty && qty.value, 10) || 1);
var items = [{ id: id, quantity: q }].concat(extras().map(function (x) { return { id: x.id, quantity: 1 }; }));
btn.disabled = true; if (msg) msg.hidden = true;
addItems(items).then(function () {
if (msg) { msg.className = 'mra-msg mra-msg--ok'; msg.innerHTML = '<span>Toegevoegd aan je winkelwagen</span><a href="/cart">Naar winkelwagen</a>'; msg.hidden = false; }
var drawer = document.querySelector('cart-drawer'); if (drawer && typeof drawer.open === 'function') { try { drawer.open(btn); } catch (e) {} }
}).catch(function (err) {
if (msg) { msg.className = 'mra-msg mra-msg--err'; msg.textContent = err.message; msg.hidden = false; }
}).finally(function () { btn.disabled = false; });
});
update();
}
function initTabs(root) {
if (root.__mra) return; root.__mra = true;
var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
tabs.forEach(function (t) {
t.addEventListener('click', function () {
tabs.forEach(function (x) { var on = x === t; x.setAttribute('aria-selected', on ? 'true' : 'false'); x.tabIndex = on ? 0 : -1; var p = document.getElementById(x.getAttribute('aria-controls')); if (p) p.hidden = !on; });
});
t.addEventListener('keydown', function (e) {
var i = tabs.indexOf(t); var n = null;
if (e.key === 'ArrowRight') n = tabs[(i + 1) % tabs.length];
if (e.key === 'ArrowLeft') n = tabs[(i - 1 + tabs.length) % tabs.length];
if (n) { n.focus(); n.click(); }
});
});
}
function initForm(root) {
if (root.__mra) return; root.__mra = true;
var sets = root.querySelectorAll('[data-mra-step]'); var steps = root.querySelectorAll('[data-mra-stepbar] span');
var back = root.querySelector('[data-mra-back]'); var next = root.querySelector('[data-mra-next]'); var submit = root.querySelector('[data-mra-submit]');
if (!next || !sets.length) return;
var cur = 0;
function go(n) {
cur = n; sets.forEach(function (s, i) { s.classList.toggle('is-active', i === n); });
steps.forEach(function (s, i) { s.classList.toggle('is-on', i <= n); });
back.style.visibility = n === 0 ? 'hidden' : 'visible'; next.hidden = n === sets.length - 1; submit.hidden = n !== sets.length - 1;
}
next.addEventListener('click', function () {
var ok = true; sets[cur].querySelectorAll('input,select,textarea').forEach(function (f) { if (ok && !f.checkValidity()) { f.reportValidity(); ok = false; } });
if (ok) go(cur + 1);
});
back.addEventListener('click', function () { go(Math.max(0, cur - 1)); });
go(0);
}
function initKeuzehulp(root) {
if (root.__mra) return; root.__mra = true;
var dataEl = root.querySelector('[data-mra-kh-data]'); var cfgEl = root.querySelector('[data-mra-kh-config]');
var products = []; var cfg = {};
try { products = JSON.parse(dataEl.textContent); cfg = JSON.parse(cfgEl.textContent); } catch (e) { console.warn('Keuzehulp data', e); return; }
function parseKw(s) {
if (!s) return 0; var total = 0;
String(s).split('+').forEach(function (part) {
var m = part.replace(/,/g, '.').match(/(?:(\d+)\s*x\s*)?(\d+(?:\.\d+)?)\s*kw/i);
if (m) total += (m[1] ? Number(m[1]) : 1) * Number(m[2]);
});
return Math.round(total * 10) / 10;
}
var eRanks = { 'A+++': 3, 'A++': 2, 'A+': 1 };
products.forEach(function (p) {
p.kw = parseKw(p.v); p.kwTxt = p.v ? p.v.replace(/kW/g, ' kW').replace(/\s+/g, ' ') : '';
p.db = parseInt(p.g, 10) || 0; p.dbTxt = p.db ? p.db + ' dB(A)' : '';
p.eRank = eRanks[(p.e || '').trim()] || 0;
var b = (p.vendor || '').toLowerCase(); p.brandRank = /lg|mitsubishi/.test(b) ? 2 : (/gree|daikin/.test(b) ? 1 : 0);
});
var Q = [
{ key: 'rooms', short: 'Ruimtes', q: 'Hoeveel ruimtes wil je koelen of verwarmen?', hint: 'Per ruimte komt er één binnenunit. Meerdere binnenunits kunnen op één buitenunit.', tip: 'Begin met het aantal kamers. Dan weten we welk systeem past.',
opts: [['1', 'Eén ruimte', 'Single split', '1'], ['2', 'Twee ruimtes', 'Duo split', '2'], ['3', 'Drie ruimtes', 'Multi split', '3'], ['4', 'Meer dan drie', 'Advies op maat', '4+']] },
{ key: 'size', short: 'Grootte', q: 'Hoe groot is de (grootste) ruimte?', hint: 'Vloeroppervlak bij een normale plafondhoogte van ca. 2,6 meter.', tip: 'Een schatting is prima. Een slaapkamer is vaak 12–20 m².',
opts: [['s', 'Tot 30 m²', 'Slaapkamer, werkkamer', 'S'], ['m', '30 – 40 m²', 'Kleine woonkamer', 'M'], ['l', '40 – 60 m²', 'Woonkamer met keuken', 'L'], ['xl', '60 – 80 m²', 'Grote open ruimte', 'XL']] },
{ key: 'iso', short: 'Isolatie', q: 'Hoe goed is de woning geïsoleerd?', hint: 'Veel glas of een zolder onder het dak vraagt meer vermogen.', tip: 'Twijfel je? Kies gemiddeld.',
opts: [['good', 'Goed', 'Nieuwbouw of goed geïsoleerd', 'A'], ['avg', 'Gemiddeld', 'Dubbel glas, deels geïsoleerd', 'B'], ['poor', 'Matig', 'Oudere woning, veel glas of zolder', 'C']] },
{ key: 'prio', short: 'Belangrijk', q: 'Wat vind je het belangrijkst?', hint: 'Dan kiezen we het model dat daar het beste bij past.', tip: 'In de slaapkamer is stil vaak het belangrijkst.',
opts: [['quiet', 'Zo stil mogelijk', 'Ideaal voor de slaapkamer', 'dB'], ['eco', 'Zo zuinig mogelijk', 'Hoogste energielabel', 'A+'], ['brand', 'Bekend topmerk', 'LG, Mitsubishi, GREE', '★'], ['price', 'Beste prijs', 'Goed en voordelig', '€']] },
{ key: 'mount', short: 'Montage', q: 'Hoe wil je de airco laten plaatsen?', hint: 'Binnen 55 km van Epe kunnen onze eigen monteurs hem compleet installeren.', tip: 'Zelf monteren mag, maar in bedrijf stellen moet door een F-gassen bedrijf.',
opts: [['self', 'Ik monteer zelf', 'Of via mijn eigen installateur', '1'], ['us', 'Inclusief montage', 'Door Mr. Airco, binnen 55 km van Epe', '2']] }
];
var state = { step: 0, a: {} };
var $ = function (s) { return root.querySelector(s); };
var qBox = $('[data-kh-ask]'), rBox = $('[data-kh-result]');
function label(q, v) { var o = q.opts.filter(function (x) { return x[0] === v; })[0]; return o ? o[1] : ''; }
function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
function renderSummary() {
var done = state.step >= Q.length;
$('[data-kh-tip]').textContent = done ? 'Dit past bij jou! Vragen? Ik help je verder.' : Q[state.step].tip;
$('[data-kh-steplabel]').textContent = done ? 'Klaar · jouw advies' : 'Stap ' + (state.step + 1) + ' van ' + Q.length;
$('[data-kh-bar]').style.width = (done ? 100 : Math.round(state.step / Q.length * 100)) + '%';
$('[data-kh-sum]').innerHTML = Q.map(function (q, i) {
var a = state.a[q.key]; var cls = (a ? 'is-done ' : '') + (i === state.step && !done ? 'is-current' : '');
return '<li class="' + cls + '"><b>' + (i + 1) + '</b><span><small>' + q.short + '</small><strong>' + (a ? esc(label(q, a)) : (i === state.step && !done ? 'Nu bezig' : 'Nog niet beantwoord')) + '</strong></span></li>';
}).join('');
}
function renderQuestion() {
var q = Q[state.step]; var val = state.a[q.key];
$('[data-kh-eyebrow]').textContent = 'Vraag ' + (state.step + 1) + ' van ' + Q.length;
$('[data-kh-q]').textContent = q.q; $('[data-kh-hint]').textContent = q.hint;
$('[data-kh-opts]').innerHTML = q.opts.map(function (o) {
return '<button type="button" class="mra-khopt" data-v="' + o[0] + '" aria-pressed="' + (val === o[0]) + '"><b>' + esc(o[3]) + '</b><span><strong>' + esc(o[1]) + '</strong><small>' + esc(o[2]) + '</small></span></button>';
}).join('');
var next = $('[data-kh-next]'); next.disabled = !val; next.textContent = state.step === Q.length - 1 ? 'Toon mijn advies' : 'Volgende';
$('[data-kh-back]').style.visibility = state.step === 0 ? 'hidden' : 'visible';
}
function pickProducts(tag, kw, prio) {
var list = products.filter(function (p) { return p.available && p.tags.indexOf(tag) > -1; });
var sized = list.filter(function (p) { return p.kw >= kw - 0.35 && p.kw <= kw + 1.2; });
if (sized.length < 2) sized = list.slice().sort(function (a, b) { return Math.abs(a.kw - kw) - Math.abs(b.kw - kw); }).slice(0, 8);
var sorters = {
quiet: function (a, b) { return (a.db || 99) - (b.db || 99) || a.price - b.price; },
eco: function (a, b) { return (b.eRank || 0) - (a.eRank || 0) || a.price - b.price; },
brand: function (a, b) { return (b.brandRank || 0) - (a.brandRank || 0) || a.price - b.price; },
price: function (a, b) { return a.price - b.price; }
};
var best = sized.slice().sort(sorters[prio] || sorters.price)[0];
var cheap = sized.slice().sort(sorters.price).filter(function (p) { return !best || p.handle !== best.handle; })[0];
return [best, cheap].filter(Boolean);
}
function renderResult() {
var a = state.a; var order = [2.5, 3.5, 5, 7];
var i = { s: 0, m: 1, l: 2, xl: 3 }[a.size] || 0; if (a.iso === 'poor') i = Math.min(3, i + 1);
var kw = order[i]; var kwTxt = String(kw).replace('.', ',');
var rooms = a.rooms || '1'; var mount = a.mount === 'us';
var title, text, chips = [], tag, install = 0, link;
if (rooms === '1') { tag = 'single split'; install = cfg.install1; link = cfg.link1; title = 'Een single split van ' + kwTxt + ' kW'; text = 'Voor één ruimte van deze grootte is een single split van ' + kwTxt + ' kW de beste keuze. Eén binnenunit, één buitenunit: stil, zuinig en je koelt én verwarmt ermee.'; chips = ['Single split', kwTxt + ' kW', label(Q[2], a.iso) + ' geïsoleerd']; }
else if (rooms === '2') { tag = 'duo split'; install = cfg.install2; link = cfg.link2; title = 'Een duo split voor twee ruimtes'; text = 'Met een duo split koel en verwarm je twee ruimtes met één buitenunit. Voor de grootste ruimte adviseren we ' + kwTxt + ' kW per binnenunit.'; chips = ['Duo split', 'Grootste ruimte ' + kwTxt + ' kW', '1 buitenunit']; }
else if (rooms === '3') { tag = 'triple split'; install = cfg.install3; link = cfg.link3; title = 'Een multi split voor drie ruimtes'; text = 'Drie ruimtes op één buitenunit. We stemmen het vermogen per kamer af, met ' + kwTxt + ' kW voor de grootste ruimte.'; chips = ['Multi split', '3 binnenunits', 'Grootste ruimte ' + kwTxt + ' kW']; }
else { title = 'Meer dan drie ruimtes: we denken graag met je mee'; text = 'Bij vier of meer ruimtes kijken we naar een combinatie van systemen. Bel of vraag een vrijblijvende offerte aan, dan maken we een voorstel.'; chips = ['Advies op maat']; link = cfg.montage; }
if (mount && rooms !== '4') chips.push('Inclusief montage');
var picks = tag ? pickProducts(tag, rooms === '1' ? kw : 2.5 * Number(rooms), a.prio) : [];
$('[data-kh-rtitle]').textContent = title; $('[data-kh-rtext]').textContent = text;
$('[data-kh-rchips]').innerHTML = chips.map(function (c) { return '<span>' + esc(c) + '</span>'; }).join('');
$('[data-kh-picks]').innerHTML = picks.map(function (p, n) {
return '<article class="mra-khpick' + (n === 0 ? ' is-best' : '') + '"><a class="mra-khpick__img" href="' + p.url + '">' + (p.img ? '<img src="' + p.img + '" alt="" loading="lazy">' : '') + '</a><div class="mra-khpick__body"><span class="mra-pill ' + (n === 0 ? 'mra-pill--solid' : 'mra-pill--blue') + '" style="text-transform:none;letter-spacing:0">' + (n === 0 ? 'Beste match' : 'Voordelig alternatief') + '</span><strong style="font-size:17px;line-height:1.25">' + esc(p.title) + '</strong><span class="mra-muted mra-small">' + esc([p.kwTxt, p.e, p.dbTxt].filter(Boolean).join(' · ')) + '</span><span style="display:flex;align-items:baseline;gap:8px"><strong style="font-size:24px;letter-spacing:-.02em" data-mra-price data-cents="' + p.price + '">' + money(p.price) + '</strong><small class="mra-muted" data-mra-btw-label>incl. btw</small></span>' + (mount && install ? '<span style="font-size:13.5px;color:var(--mra-blue);font-weight:600">Inclusief montage: <span data-mra-price data-cents="' + (p.price + install) + '">' + money(p.price + install) + '</span></span>' : '') + '<a class="mra-btn mra-btn--blue mra-btn--sm" style="align-self:flex-start;margin-top:4px;color:#fff" href="' + p.url + '">Bekijk deze airco</a></div></article>';
}).join('') || '<div class="mra-card" style="padding:24px">We stellen graag een systeem op maat voor je samen.</div>';
$('[data-kh-ctatitle]').textContent = mount ? 'Klaar voor een vrijblijvende offerte?' : 'Nog vragen over je keuze?';
$('[data-kh-ctatext]').textContent = mount ? 'Binnen 24 uur een totaalprijs voor airco en montage.' : 'Bel ' + cfg.phone + ' of stuur ons een WhatsApp.';
var cta = $('[data-kh-cta]'); cta.textContent = mount || rooms === '4' ? 'Vraag montageofferte aan' : 'Bekijk alle passende airco’s'; cta.href = mount || rooms === '4' ? cfg.montage : (link || '/collections/all');
applyBtw();
}
function render() {
var done = state.step >= Q.length; qBox.hidden = done; rBox.hidden = !done;
renderSummary(); if (done) renderResult(); else renderQuestion();
}
root.addEventListener('click', function (e) {
var o = e.target.closest('.mra-khopt'); if (o) { state.a[Q[state.step].key] = o.getAttribute('data-v'); renderQuestion(); renderSummary(); return; }
if (e.target.closest('[data-kh-next]')) { if (state.a[Q[state.step].key]) { state.step++; render(); root.scrollIntoView({ behavior: 'smooth', block: 'start' }); } return; }
if (e.target.closest('[data-kh-back]')) { state.step = Math.max(0, state.step - 1); render(); return; }
if (e.target.closest('[data-kh-restart]')) { state = { step: 0, a: {} }; render(); }
});
render();
}
function init() {
applyBtw();
document.querySelectorAll('[data-mra-pdp]').forEach(initPdp);
document.querySelectorAll('[data-mra-tabs]').forEach(initTabs);
document.querySelectorAll('[data-mra-form]').forEach(initForm);
document.querySelectorAll('[data-mra-keuzehulp]').forEach(initKeuzehulp);
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
document.addEventListener('shopify:section:load', init);
})();
